// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-valid.text-valid--spec[data-v-b01d84d6]{font-size:.9667rem;font-weight:600;line-height:1.77;letter-spacing:.1rem;color:#00afa1;text-align:center;opacity:1;text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
